import React from 'react';
import react, { useState, useContext } from 'react';
import { AuthContext } from './AuthContext';
import { Route } from 'react-router';
import Layout from './components/Layout/Layout';
import { Login } from './components/Login';
import { ActiveAccount } from './components/ActiveAccount';
import { RegisterComponent } from './components/RegisterComponent';
import { ChangePwd } from './components/ChangePwd/ChangePwd';
import { ValidateNumber } from './components/Validate/ValidateNumber';
import { ValidateContainer } from './components/Validate/ValidateContainer';
import { UserDelete } from './components/UserDelete/UserDelete';
import './custom.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './components/slide-pane.scss';
import './components/gdacs_2.0.css';
import './components/register.css';
import { GdacsHome } from './components/Layout/GdacsHome';
import { UsernamePassword } from './components/UserCredentials/UsernamePassword';
import { clearToken, getToken, saveToken } from './components/Hooks/Token';
import { getAPI } from './components/GdacsAPI';

export default function App() {
    const displayName = App.name;
    const [loggedIn, setLoggedIn] = React.useState();
    const [token, setToken] = React.useState();
    const [username, setUsername] = React.useState();
    const [password, setPassword] = React.useState();
    const [userData, setUserData] = React.useState();

    const login = (data) => {
        setUserData(data);
        saveToken(data.token);
        setLoggedIn(!!data.token);
        setToken(data.token);
        setUsername(data.username);
        setPassword(data.password);
    }

    const logout = () => {
        setLoggedIn(false);
        clearToken();
        setToken(undefined);
        setUsername(undefined);
        setUserData(undefined);
        setPassword(undefined);
    }

    const updateUser = (userData) => {
        getUserData(userData);
        return;
    }

    async function getUserData(userData) {
        let json = {
            username: userData.username
        }

        const tokenUpdate = token === undefined ? userData.token : token;

        const settingsCredentials = {
            method: 'POST',
            type: 'no-cors',
            body: JSON.stringify(json),
            headers: {
                'Authorization': 'Bearer ' + tokenUpdate,
                Accept: 'application/json',
                'Content-Type': 'application/json',
            }
        };

        const responseCredentials = await fetch(getAPI() + `api/register/Users/getuserbyusername/`, settingsCredentials)
        if (!responseCredentials.ok) {
            const resp = await responseCredentials.json();
            return;
        }
        else {
            const dataUserLog = await responseCredentials.json();
            setUserData(dataUserLog);
        }
    }

    return (
        <AuthContext.Provider value={{ isLoggedIn: loggedIn, token: token, username: username, password: password, login: login, logout: logout, data: userData, update: updateUser }}>
            <Layout>
                <Route exact path='/' component={Login} />
                <Route exct path='/Activate' component={ActiveAccount} />
                <Route exact path='/EditProfile' component={RegisterComponent} />
                <Route exact path='/Home' component={GdacsHome} />
                <Route exact path='/Register' component={UsernamePassword} />
                <Route exact path='/ChangePwd' component={ChangePwd} />
                {/*                <Route exact path='/ValidateNumber' component={ValidateNumber} />*/}
                <Route exact path='/ValidateContainer' component={ValidateContainer} />
                <Route exact path='/UserDelete' component={UserDelete} />
            </Layout>
        </AuthContext.Provider>
    );
}
